<!-- One emoji, drawn at 16×16 and scaled up with hard pixels (MVP 6).
     role="img" + aria-label = the character itself, so assistive tech names it
     exactly as the sender typed it. Falls back to the plain character when
     there is no canvas (SSR, tests) or the platform drew nothing. -->
<template>
  <span class="pm-emoji" role="img" :aria-label="char">
    <img v-if="src" class="pm-emoji__img" :src="src" alt="" draggable="false" />
    <span v-else class="pm-emoji__char" aria-hidden="true">{{ char }}</span>
  </span>
</template>

<script setup>
import { computed, inject, unref } from 'vue';
import { emojiDataUrl } from '../pm/emoji-raster.js';

const props = defineProps({
  char: { type: String, required: true },
  /** A CSS custom property to multiply-tint with (`--lcd-glass`). Defaults to
   *  whatever the enclosing <Lcd> provides; '' for none. */
  tint: { type: String, default: null },
});

const provided = inject('pmLcdTint', '');
const tintVar = computed(() => (props.tint ?? unref(provided)) || '');
const src = computed(() => emojiDataUrl(props.char, tintVar.value));
</script>
